import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'

import { NewInput, Input } from 'shared/components'

import { FormContext } from '../../context'

const FormInput = ({ name, oldInput, disabled, ...props }) => {
  const form = useContext(FormContext)

  if (form == null) {
    throw new Error(
      'FormInput should be defined inside Form, also please check form property is set'
    )
  }

  const ComponentRender = oldInput ? Input : NewInput

  const field = form.fields[name]

  if (field == null) {
    throw new Error(`FormInput has no such field: ${name}`)
  }

  const value = field.pureValue == null ? FormInput.EMPTY_STR : field.pureValue

  return (
    <ComponentRender
      id={field.id}
      name={name}
      disabled={disabled || field.readonly}
      value={value}
      onBlur={field.onBlur}
      errorMessage={field.showError ? field.error.message : ''}
      onChange={props.onChange ?? field.onChange}
      {...props}
    />
  )
}

FormInput.EMPTY_STR = ''

FormInput.propTypes = {
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  secondLabel: PropTypes.node,
  oldInput: PropTypes.bool,
  bordered: PropTypes.bool,
  className: PropTypes.string,
}

export default observer(FormInput)
